import Vue from 'vue';
import store from './../../store';
import { encodePathSegment } from '@/utils/url';

// When the request succeeds
const success = () => {
  store.dispatch('group/getGroup');
};

// When the request fails
const failed = () => {};

export default (group) => {
  if (
    !group.name
  ) {
    failed();
  } else {
    Vue.$http
      .patch(`CustomerGroups/${encodePathSegment(group.id)}`, group)
      .then((response) => {
        success(response);
      })
      .catch((error) => {
        failed(error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/group/edit.js